import { createAsyncTypes } from '../../utils';

const types = createAsyncTypes('myloungeArticles', [
    'FETCH_CATEGORY_SUBLINE'
]);

export default types;
